export function checkClipboardTypes(type, item) {
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var isDOMStringList = function isDOMStringList(t) {
    return !t.indexOf && !!t.contains;
  };
  return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
}
export function isPastedFile(rawEvent) {
  var clipboardData = rawEvent.clipboardData;
  if (!clipboardData) {
    return false;
  }
  return checkClipboardTypes(clipboardData.types, 'Files');
}